import React, { useContext, useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";
import { FilterContext } from "../../context/Filter";
import { getintendedapp } from "../../pages/piplineAndService/pipline&servicekpi";

const Barchartcard = () => {
  const [intendedData, setIntendedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { arn: parArn, childArn } = useContext(FilterContext);

  useEffect(() => {
    const fetchData = async () => {
      const value = childArn || parArn;
      if (!value) return;

      try {
        setLoading(true);
        setError(null);

        const key = childArn ? "childArn" : "parArn";
        const payload = { [key]: value };

        const res = await getintendedapp(payload);
        const apiData = res?.data || res;

        let validData = [];
        if (Array.isArray(apiData)) {
          validData = apiData.filter(
            (item) => item?.key && typeof item?.doc_count === "number"
          );
        } else if (apiData?.success && Array.isArray(apiData?.result)) {
          validData = apiData.result.filter(
            (item) => item?.key && typeof item?.doc_count === "number"
          );
        }

        validData.sort((a, b) => b.doc_count - a.doc_count);
        setIntendedData(validData);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    if (parArn || childArn) fetchData();
  }, [parArn, childArn]);

  const yAxisData = intendedData.map((item) => item.key);
  const seriesData = intendedData.map((item) => item.doc_count);

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) =>
        params?.length > 0
          ? `${params[0].name}<br/>${params[0].marker}Count: ${params[0].value}`
          : "",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      top: "3%",
      containLabel: true,
    },
    dataZoom: [
      {
        type: "slider",
        yAxisIndex: 0,
        width: 10,
        right: 0,
        start: 0,
        end: 100,
        showDetail: false,
        brushSelect: false,
        backgroundColor: "#f5f5f5",
        fillerColor: "#c0c0c0",
      },
    ],
    xAxis: [
      {
        type: "value",
        splitLine: { show: false },
        axisLine: { show: true, lineStyle: { color: "#999" } },
        axisLabel: { color: "#333", fontSize: 10 },
      },
    ],
    yAxis: [
      {
        type: "category",
        data: yAxisData,
        inverse: true, // highest value on top
        axisTick: { alignWithLabel: true },
        splitLine: { show: false },
        axisLine: { show: true, lineStyle: { color: "#999" } },
        axisLabel: {
          color: "#333",
          fontSize: 10,
          formatter: (value) =>
            value.length > 20 ? value.substring(0, 20) + "..." : value,
        },
      },
    ],
    series: [
      {
        name: "Count",
        type: "bar",
        barWidth: "30%",
        data: seriesData,
        itemStyle: {
          color: (params) => {
            const colorList = ["#649b9e", "#446294", "#01d0bc", "#f7b731"];
            return colorList[params.dataIndex % colorList.length];
          },
          borderRadius: [0, 10, 10, 0], // rounded right corners for horizontal bars
        },
        label: { show: false },
      },
    ],
  };

  if (loading)
    return (
      <div className="w-full h-[250px] flex items-center justify-center">
        <div className="text-gray-600">Loading chart data...</div>
      </div>
    );

  if (error)
    return (
      <div className="w-full h-[250px] flex items-center justify-center">
        <div className="text-red-600">Error: {error}</div>
      </div>
    );

  if (intendedData.length === 0)
    return (
      <div className="w-full h-[250px] flex items-center justify-center">
        <div className="text-gray-500">No data available</div>
      </div>
    );

  return (
    <div className="w-full h-[200px]">
      <EChartsReact
        option={option}
        style={{ width: "100%", height: "100%" }}
        opts={{ renderer: "canvas" }}
      />
    </div>
  );
};

export default Barchartcard;
